import React, { useContext, useEffect } from "react";
import ILoadUserDTO from "../../../models/DTO/ILoadUserDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ISupplierModel from "../../../models/ISupplierModel";
import IVendorModel from "../../../models/IVendorModel";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { BusinessProfileSidebar } from "./BusinessProfileSidebar/BusinessProfileSidebar";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import UIService from "../../../services/UIService";

type Props = {
    profileModel: ISupplierModel | IVendorModel;
};

export const BusinessProfile = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const breadcrumbs = [
        { title: "Dashboard", url: "/dashboard" },
        { title: "Business Profile", url: "/business/profile" },
    ];

    useEffect(() => {
        document.title = `Orderwerks >> Business Profile`;
    }, []);

    const cancelSidebar = (refreshData?: boolean) => {
        uiContext.toggleSidebar(false);

        const payload: ILoadUserDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
        };

        socket.emit(EndpointsEnum.AppLoadUser, payload);

        uiContext.setActivityIndicator(true);
    };

    const getSidebarComponent = () => {
        return <BusinessProfileSidebar profileModel={props.profileModel} cancel={cancelSidebar} />;
    };

    const showSidebar = () => {
        const sidebarComp = getSidebarComponent();
        uiContext.setSidebarComponent(sidebarComp);
        uiContext.toggleSidebar(true);
    };

    return (
        <div className="BusinessProfile">
            {/*<Breadcrumbs navItems={breadcrumbs} />*/}

            <div className="row">
                <div className={"col-12 d-flex mt-3 align-items-center"}>
                    <OwTitle className={"me-2"} title={"business_profile"} leftIconName={"fad fa-building-magnifying-glass"} />
                    <div>
                        <OwButton leftIconClass={"far fa-pencil"} title={"edit"} fn={showSidebar} />
                    </div>
                </div>
            </div>

            <div className="row mt-4 mb-4">
                <h5 className="col-12 pb-0 mb-0">{props.profileModel.name}</h5>
                <div className={"col-12 mt-2"}>
                    <OwLabel title={"email"} postText={":"} className={"me-1"} noBottomMargin={true} isBold={true} />
                    {props.profileModel.email}
                </div>
            </div>

            <div className="row mt-5 mt-md-2">
                <div className="col-auto">
                    <div className="">
                        <div
                            className={
                                "p-2 rounded-top " +
                                (UIService.isMainViewLight() ? "charcoal-grey-bg white-four" : "white-four-bg text-dark")
                            }>
                            <OwTitle tag={"h4"} title={"bill_to"} isBold={true} />
                        </div>
                        <div className="p-2 rounded-bottom border">
                            <div className={"d-flex"}>
                                <div className={"fal fa-map-marker-alt me-2 mt-1"} />
                                <AddressDisplay
                                    showName={true}
                                    showCompanyName={true}
                                    address={props.profileModel.Bill_To}
                                    showPhone={true}
                                    hideEmail={true}
                                    hideMobile={true}
                                />
                            </div>
                            <div className="flex">
                                {supplierModel.has_google_maps ? (
                                    <OwGoogleStaticMap address={props.profileModel.Bill_To} className={"mt-2"} />
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"col-auto"}>
                    <div className={""}>
                        <div
                            className={
                                "border rounded-top p-2 " +
                                (UIService.isMainViewLight() ? "charcoal-grey-bg white-four" : "white-four-bg text-dark")
                            }>
                            <OwTitle tag={"h4"} title={"ship_to"} isBold={true} />
                        </div>
                        <div className="p-2 rounded-bottom border">
                            <div className={"d-flex"}>
                                <div className={"fal fa-map-marker-alt me-2 mt-1"} />
                                <AddressDisplay
                                    showName={true}
                                    showCompanyName={true}
                                    address={props.profileModel.Ship_To}
                                    showPhone={true}
                                    hideEmail={true}
                                    hideMobile={true}
                                />
                            </div>
                            <div className="flex">
                                {supplierModel.has_google_maps ? (
                                    <OwGoogleStaticMap address={props.profileModel.Ship_To} className={"mt-2"} />
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
